/**
 * ADRE Online Licensing System Web API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


/**
 * Validate user with personal information request type
 */
export class ValidateUserWithPersonalInformationRequestModel { 
    /**
     * License Number requiring 2 letters followed by 9 numbers
     */
    licenseNo: string;
    /**
     * Last 4 digits of Social Security Number
     */
    ssnSuffix: string;
    /**
     * Birth date
     */
    birthDate: Date;
    /**
     * IP address of the client
     */
    visitorIPAddress: string;
    /**
     * Flag when password reset is initiated on the client
     */
    passwordReset?: boolean;
}



// WEBPACK FOOTER //
// ./src/app/model/validateUserWithPersonalInformationRequestModel.ts